// extracted by mini-css-extract-plugin
export default {"gradient":"CardGradientBorderWrapper-module__gradient___Ceixs"};